export enum LogLevel {
    None = 0,
    Critical = 1,
    Error = 2,
    Warning = 3,
    Information = 4,
    Debug = 5,
    Trace = 6
}
